<template>
  <div class="container-fluid">
    <div class="page-title">
      <div class="row">
        <div class="col-6">
          <h3>Alta usuarios</h3>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-6">
        <div class="card">
          <div class="card-header pb-0">
            <h4>Registrar administrador</h4>
            <span>Complete el formulario para dar de alta un nuevo usuario administrador.</span>
          </div>
          <div class="card-body">
            <form class="theme-form" @submit.prevent="onSubmit">
              <div class="mb-3">
                <label class="col-form-label pt-0" for="email">Correo electrónico</label>
                <input
                  id="email"
                  v-model="form.email"
                  type="email"
                  class="form-control"
                  placeholder="admin@ejemplo.com"
                  required
                />
              </div>
              <div class="mb-3">
                <label class="col-form-label pt-0" for="nombre">Nombre</label>
                <input
                  id="nombre"
                  v-model="form.nombre"
                  type="text"
                  class="form-control"
                  placeholder="Nombre del administrador"
                />
              </div>
              <div class="mb-3">
                <label class="col-form-label pt-0" for="password">Contraseña</label>
                <input
                  id="password"
                  v-model="form.password"
                  type="password"
                  class="form-control"
                  placeholder="Mínimo 6 caracteres"
                  required
                  minlength="6"
                />
              </div>
              <div v-if="errorMsg" class="alert alert-danger" role="alert">
                {{ errorMsg }}
              </div>
              <div v-if="successMsg" class="alert alert-success" role="alert">
                {{ successMsg }}
              </div>
              <div class="card-footer text-end px-0">
                <button type="submit" class="btn btn-primary" :disabled="loading">
                  {{ loading ? 'Guardando...' : 'Dar de alta' }}
                </button>
                <button type="button" class="btn btn-secondary ms-2" @click="resetForm">
                  Limpiar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usersApi } from '@/api/users';
import Swal from 'sweetalert2';
import { normalizeApiError } from '@/utils/error-handler';

export default {
  name: 'AltaUsuarios',
  data() {
    return {
      form: {
        email: '',
        nombre: '',
        password: '',
      },
      loading: false,
      errorMsg: '',
      successMsg: '',
    };
  },
  methods: {
    async onSubmit() {
      this.errorMsg = '';
      this.successMsg = '';
      this.loading = true;
      try {
        await usersApi.createAdmin(this.form);
        this.successMsg = 'Administrador registrado correctamente.';
        this.resetForm();

        await Swal.fire({
          icon: 'success',
          title: 'Usuario creado',
          text: 'El usuario se ha creado y se envió el correo de verificación.',
          confirmButtonColor: '#FBC903',
        });
      } catch (e) {
        const message = normalizeApiError(e, 'Error al registrar. Intente de nuevo.');

        this.errorMsg = message;

        await Swal.fire({
          icon: 'error',
          title: 'Error al crear usuario',
          text: message,
          confirmButtonColor: '#FBC903',
        });
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.form = { email: '', nombre: '', password: '' };
      this.errorMsg = '';
      this.successMsg = '';
    },
  },
};
</script>
